import type { ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Delete a new item category
 *
 * @endpoint DELETE /api/me/item_categories/{internal_id}
 * @scope saas
 * @see https://flecto.dev/api-4724138
 */
export async function deleteItemCategory(
  internal_id: ParameterID,
  new_category_id?: ParameterID
): Promise<void> {
  if (new_category_id) {
    await api.delete(
      `/api/me/item_categories/${internal_id}/?new_category_id=${new_category_id}`
    )
  }
  else {
     await api.delete(
       `/api/me/item_categories/${internal_id}`
     )
  }
}
